import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AUTH_PREFIX_PATH,
  APP_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from "configs/AppConfig";
import { getSubscriptionData } from "utils/subscriptionSession";
import { isDashboardBlocked } from "utils/subscriptionUtils";

const ProtectedRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  const blocked = isDashboardBlocked(getSubscriptionData());

  if (blocked) {
    const allowPrefix = `${APP_PREFIX_PATH}/pages/setting/subscription`;
    const isAllowed = location.pathname.startsWith(allowPrefix);

    if (!isAllowed) {
      return <Navigate to={allowPrefix} replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
